import { render, staticRenderFns } from "./PhoneSetting.vue?vue&type=template&id=2700888c"
import script from "./PhoneSetting.vue?vue&type=script&lang=js"
export * from "./PhoneSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports